"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function IrrigationHero() {
  return <section data-section-id="2838" id="irrigationhero" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {/* Background Image con animación Ken Burns */}
      <div className="absolute inset-0 z-0">
        <img src="https://aaeagleplumbing.com/wp-content/uploads/2026/08/Irrigation_system_work.jpg" alt="Professional technician inspecting industrial pump systems" loading="eager" decoding="async" className="h-full w-full object-cover animate-[kenburns_20s_ease-in-out_infinite_alternate]" />
      </div>

      {/* Gradiente exacto del layout original */}
      <div className="absolute inset-0 z-10" style={{
      background: "linear-gradient(to bottom, hsla(220, 95%, 10%, 0.85) 0%, hsla(220, 95%, 10%, 0.65) 45%, hsla(220, 95%, 10%, 0.9) 100%)"
    }} />

      {/* Contenedor principal con la cuadrícula y espaciado exacto */}
      <div className="relative z-20 mx-auto flex min-h-screen w-full max-w-7xl flex-col px-6 pt-32 pb-24 md:px-10 lg:px-16">
        <div className="flex flex-1 items-center">
          <div className="max-w-4xl">
            {/* Tag superior con la línea horizontal */}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-accent" />
              <span className="font-default text-xs tracking-[0.25em] uppercase text-accent font-bold">
                Commercial & Residential Plumbing / Miami & South Florida
              </span>
            </div>

            {/* Título adaptado con el tamaño de fuente responsivo exacto */}
            <h1 className="font-default font-bold leading-[0.95] tracking-tight text-white mb-6" style={{
            fontSize: "clamp(3.5rem, 10vw, 6.5rem)"
          }}>
              Irrigation & <br />
              <span className="text-accent">Pool Pump Systems</span>
            </h1>

            {/* Párrafo descriptivo */}
            <p className="mt-8 max-w-2xl font-default text-lg leading-relaxed md:text-xl text-white/90">
              Pool pumps wear out, lose prime, or stop circulating altogether. Irrigation systems spring leaks, fail at the zone valves, or run off-schedule and drive up water costs. In South Florida's salt air and hard water conditions, the wear happens faster than most property owners expect.
            </p>

            {/* Zona de CTA: Botón y Teléfono */}
            <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
              <Button asChild className="bg-accent text-black hover:bg-accent-hover active:bg-accent-active hover:-translate-y-1 active:translate-y-0 hover:scale-105 active:scale-95 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-medium hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring px-10 py-5 h-auto text-base md:text-lg font-semibold rounded-lg">
                <Link to="/ContactPage">
                  Get a Free Quote
                </Link>
              </Button>
              <span className="font-default text-white/90 ml-2 font-semibold">
                Or call us at{" "}
                <a href="tel:3055613895" className="text-accent hover:underline hover:opacity-80 transition-all">
                  305-561-3895
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* Indicador de Scroll inferior */}
        <div className="relative mt-auto flex items-end justify-between pt-12">
          <div className="flex flex-col items-center gap-3">
            <span className="font-default text-[10px] tracking-[0.4em] uppercase text-white/70" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Scroll
            </span>
            <div className="relative h-16 w-px overflow-hidden">
              <div className="absolute inset-0 animate-[scrollLine_2s_ease-in-out_infinite] bg-white/60" />
            </div>
          </div>
        </div>
      </div>

      {/* Estilos e Inyecciones de Keyframes */}
      <style>{`
        @keyframes kenburns { 0% { transform: scale(1) translate(0, 0); } 100% { transform: scale(1.12) translate(-1%, -1%); } }
        @keyframes scrollLine { 0% { transform: translateY(-100%); } 100% { transform: translateY(100%); } }
      `}</style>
    </section>;
}